var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"e-date-box",attrs:{"datetime":_vm.dateString}},[_c('div',{staticClass:"e-date-box__day"},[_vm._v(_vm._s(_vm.zeroPaddedDay))]),_c('div',{staticClass:"e-date-box__month"},[_vm._v(_vm._s(_vm.formattedMonth))])])}
var staticRenderFns = []

export { render, staticRenderFns }